
const namespaced = true;

const state = {
  searchString: ``,
};

const mutations = {
  SET_SEARCH_STRING(state, searchString) {
    state.searchString = searchString || ``;
  },
};

const actions = {};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
